import { getCmsStopsList } from "../../../app/api/getCmsStopsList";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { ICMSStops, ICmsStopsResponse } from "../../../Orchestrator/Types/Interface/ICmsStops";


class GetCmsStopsListAction extends BaseAction<ICMSStops[], void> {
  override async run(): Promise<ICMSStops[] | null> {
    let listOfStops: ICMSStops[] = [];
    try {
      const response: IApiResponse<ICmsStopsResponse> = await getCmsStopsList();
      if (response.status === "ok" && response.answer) {
        const Stops = response.answer.data;
        listOfStops = Stops;
        updateRecoilState("cmsStopsAtom", listOfStops);
      } else {
        console.warn("Failed to fetch CMS Stops.");
      }
    } catch (error: any) {
      console.error("Error fetching CMS Stops :", error);
    } finally {
      return listOfStops;
    }
  }
}

export const getCmsStopsListAction = new GetCmsStopsListAction();
